export const DEFAULT_STATUS_CHECK_MINUTES = 20;
export const DEFAULT_PING_INTERVAL_SECONDS = 30;
export const MIN_PING_INTERVAL_SECONDS = 5;
export const MAX_PING_INTERVAL_SECONDS = 600;
